
import axios from '../plugins/axiosPlugins'

import runEvn from '../modular/runEvn/RunEvn'
const baseURL = runEvn().apiBaseUrl;


//报名
export const postActSignUp = (data): Promise<any> => {
    return axios.post(`${baseURL}/ActSignUp`, data);
}
